module.exports = __webpack_public_path__ + "static/media/flag-usa.38e1e03a.svg";